import { render, staticRenderFns } from "./PaymentOption.vue?vue&type=template&id=4725c054&scoped=true&"
import script from "./PaymentOption.vue?vue&type=script&lang=js&"
export * from "./PaymentOption.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOption.vue?vue&type=style&index=0&id=4725c054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4725c054",
  null
  
)

export default component.exports